import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-datepicker-field',
  templateUrl: './datepicker-field.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class DatepickerFieldComponent implements AfterViewInit {
  @ViewChild('dp') datePicker: NgbInputDatepicker;

  @Input() controlName!: string;
  @Input() id = '';
  @Input() label = '';
  @Input() placeholder = 'DD/MM/AAAA';
  @Input() inputClass = '';
  @Input() required = false;
  @Input() readOnly = false;
  @Input() autocomplete = 'off';
  @Input() showValidState = false;
  @Input() validMessage: string | null = '';
  @Input() showInvalidState = false;
  @Input() invalidMessage: string | null = '';
  @Input() showToggler = true;
  @Input() maxDate?: NgbDateStruct;
  @Input() minDate?: NgbDateStruct;

  ngAfterViewInit(): void {
    if (!this.datePicker) return;

    if (this.minDate) this.datePicker.minDate = this.minDate;
    if (this.maxDate) this.datePicker.maxDate = this.maxDate;
  }

  get inputId(): string {
    return this.id || this.controlName;
  }

  get isInvalid(): boolean {
    return this.showInvalidState;
  }

  get isValid(): boolean {
    return this.showValidState;
  }
}
